












import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class SocialIcon extends Vue {
  @Prop({ required: true }) name!: string
  @Prop({ default: false }) noHover!: boolean
  @Prop() link!: string

  get iconSrc() {
    if (this.noHover) {
      return require(`!!raw-loader!@/assets/social-icons/${this.name}.svg`)
    }
    return require(`!!raw-loader!@/assets/icons/${this.name}.svg`)
  }
}
